import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import BryxColors from "../types/theme";
import { Box, ClickAwayListener, Paper, Popper } from "@mui/material";
import BryxBox from "./BryxBox";
import BryxIcon from "./BryxIcon/BryxIcon";
import BryxButton from "./BryxButton";
import { useState } from "react";
export const BryxAddButtonListItem = styled(BryxButton)(({ theme }) => ({
    padding: "8px 0 8px 16px !important",
    justifyContent: "left",
    color: BryxColors.notify(theme.palette.mode, "inactive"),
    "&:hover": {
        backgroundColor: `${BryxColors.brand3(theme.palette.mode)} !important`,
        color: BryxColors.brandPrimary(theme.palette.mode),
    },
}));
const BryxAddButton = styled(({ height, width, onClick, className, noPopper, children, colorSetting, ...rest }) => {
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openedHeight = height ?? "178px";
    const openedWidth = width ?? "167px";
    const handleClick = (e) => {
        setOpen((prev) => !prev);
        setAnchorEl(e.currentTarget);
        onClick?.();
    };
    const handleClickAway = () => {
        setOpen(false);
    };
    const cleanProps = { ...rest, variant: undefined };
    return (_jsx(ClickAwayListener, { onClickAway: handleClickAway, children: _jsxs(Box, { sx: { width: openedHeight, display: "flex", alignItems: "center", flexDirection: "column" }, children: [_jsx(Button, { ...cleanProps, disableRipple: true, className: (className ?? "") + (open ? " active" : ""), onClick: handleClick, children: _jsx(BryxIcon, { iconName: "add", lgIconSize: true }) }), _jsx(Popper, { open: !noPopper && open, anchorEl: anchorEl, placement: "bottom", children: _jsx(Paper, { children: _jsx(BryxBox, { isFlex: true, fullWidth: true, sx: {
                                py: 2,
                                px: 1,
                                boxShadow: "0px 7px 20px 0px rgb(0 0 0 / 14%), 0px 7px 10px -10px rgb(0 0 0 / 12%)",
                                borderRadius: "4px",
                                marginTop: "8px",
                                padding: "8px 4px",
                                flexDirection: "column",
                                width: openedWidth,
                                maxHeight: openedHeight,
                                overflow: "auto",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                                "&::-webkit-scrollbar": { display: "none" },
                                rowGap: "4px",
                            }, children: children }) }) })] }) }));
})(({ colorSetting, theme }) => {
    const mode = theme.palette.mode;
    return {
        position: "relative",
        margin: "0 auto 0 auto",
        width: "32px",
        height: "32px",
        borderRadius: "4px",
        fontSize: "13px",
        padding: 0,
        boxShadow: "none",
        fontWeight: 400,
        lineHeight: "18px",
        textTransform: "none",
        fontStyle: "normal",
        minWidth: "32px",
        backgroundColor: colorSetting == "red" || colorSetting == undefined ? BryxColors.brand1(mode) : BryxColors.brand4(mode),
        border: `1px solid ${colorSetting == "red" || colorSetting == undefined ? BryxColors.brand1(mode) : BryxColors.brand4(mode)}`,
        color: colorSetting == "red" || colorSetting == undefined ? BryxColors.brand1(mode) : BryxColors.brand4(mode),
        "&.active": {
            backgroundColor: colorSetting == "red" || colorSetting == undefined ? "unset !important" : BryxColors.brandDark2(mode),
            border: `1px solid ${colorSetting == "red" || colorSetting == undefined ? BryxColors.brand(mode, 0) : BryxColors.brand4(mode)}`,
            color: "unset !important",
        },
        "&.active svg": {
            transitionDuration: "0.5s",
            transitionProperty: "rotate",
            rotate: "-45deg",
        },
        "&:not(.active) svg": {
            transitionDuration: "0.5s",
            transitionProperty: "rotate",
            rotate: "90deg",
        },
        "&:hover": {
            backgroundColor: colorSetting == "red" || colorSetting == undefined ? BryxColors.brand(mode, 0) : BryxColors.brandDark2(mode),
            border: `1px solid ${colorSetting == "red" || colorSetting == undefined ? BryxColors.brand(mode, 0) : BryxColors.brand4(mode)}`,
            color: BryxColors.brand(mode, 0),
            boxShadow: "none",
        },
        "&:hover:not(.active) svg": {
            transitionDuration: "0.5s",
            transitionProperty: "rotate",
            rotate: "0deg",
        },
        "&:hover:not(.active) path": {
            fill: "white",
        },
        "&:hover.active svg": {
            transform: "scale(1.25)",
        },
        "&.active path": {
            fill: colorSetting == "red" || colorSetting == undefined ? BryxColors.brand1(mode) : "white",
        },
        "&:not(.active) path": {
            fill: colorSetting == "red" || colorSetting == undefined ? "white" : BryxColors.brandDark2(mode),
        },
    };
});
export default BryxAddButton;
